import React, { FC } from "react";
import useI18n from "@I18n/hooks/useI18n";
import GooglePlayStoreSvgFr from "./google-play-store-fr.svg";
import GooglePlayStoreSvgNl from "./google-play-store-nl.svg";
import GooglePlayStoreSvgEn from "./google-play-store-en.svg";

const ICONS = {
  fr: GooglePlayStoreSvgFr,
  nl: GooglePlayStoreSvgNl,
  en: GooglePlayStoreSvgEn,
};

export const GooglePlayStoreIcon: FC<JSX.IntrinsicAttributes> = (props) => {
  const { locale } = useI18n();

  const Svg = ICONS[locale] || ICONS.en;

  return <Svg {...props} />;
};
